/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'placeholders': {
    width: 20.11,
    height: 24.857,
    viewBox: '0 0 20.11 24.857',
    data: '<path pid="0" d="M18.306 4.322a10.036 10.036 0 00-16.5 0A10.038 10.038 0 00.637 13.57a7.905 7.905 0 001.457 2.405l7.3 8.575a.868.868 0 001.323 0l7.3-8.573a7.913 7.913 0 001.457-2.4 10.04 10.04 0 00-1.168-9.255zm-.461 8.645a6.2 6.2 0 01-1.146 1.878l-6.639 7.8-6.643-7.8a6.2 6.2 0 01-1.148-1.883 8.3 8.3 0 01.965-7.652 8.3 8.3 0 0113.641 0 8.3 8.3 0 01.97 7.657z" _fill="#959595"/><path pid="1" d="M10.055 5.157a4.867 4.867 0 104.867 4.867 4.873 4.873 0 00-4.867-4.867zm0 8a3.129 3.129 0 113.129-3.129 3.132 3.132 0 01-3.129 3.125z" _fill="#959595"/>'
  }
})
